export default function customWarning() {
  console.warn('You have entered an invalid country code or empty input');
}